export const artikel3 = `
Bagi umat Islam yang melakukan perjalanan jauh <strong>(minimal 82 km)</strong> ada rukhsah atau dispensasi dalam hal ibadah shalat, yaitu jamak. Shalat jamak adalah melaksanakan dua shalat fardhu dalam satu waktu. Shalat yang boleh di jamak adalah shalat dhuhur dengan ashar dan magrib dengan isya dan yang bisa di qashar hanya shalat dzuhur dan ashar dan harus dilaksanakan di waktu dzuhur.

Shalat jamak ada 2 macam:

- <strong>(1) jamak taqdim</strong>, yaitu melakukan shalat dhuhur dan ashar di waktu dhuhur atau melakukan shalat maghrib dan isya di waktu maghrib.

- <strong>(2) jamak ta’khir</strong> yaitu melakukan shalat dhuhur dan ashar di waktu shalat ashar atau melakukan shalat maghrib dan isya di waktu isya’.

<strong>JAMAK TAQDIM</strong>
Syarat melaksanakan shalat jamak taqdim ada 4 (empat), yaitu:

<strong>1.Tertib: </strong>
Maksud tertib di sini adalah mendahulukan shalat pertama daripada yang kedua. Seperti mendahulukan shalat dzuhur daripada ashar atau mendahulukan shalat maghrib daripada isya’ dan mendahulukan shalat pada waktunya terlebih dahulu.

<strong>2.Niat: </strong>
Niat jamak shalat di shalat yang pertama, pelaksanaan niat disunahkan bersamaan dengan takbiratul ihram.

Adapun lafal niat jamak taqdim shalat dzuhur dan ashar adalah sebagaimana berikut:

أُصَلِّى فَرْضَ الظُّهْرِ أَرْبَعَ رَكَعَاتٍ مَجْمُوْعًا بِالْعَصْرِ جَمْعَ تَقْدِيْمٍ لِلهِ تَعَالَى

Ushallî fardladh-dhuhri arba‘a raka‘âtin majmû‘an bil-‘ashri jam‘a taqdîmin lillâhi ta‘ala

Artinya: “Saya niat shalat fardlu dzuhur empat rakaat dijamak bersama ashar dengan jamak taqdim karena Allah ta’ala”.

 Niat jama‘ taqdim shalat maghrib dan isya:

 أُصَلِّى فَرْضَ المَغْرِبِ ثَلَاثَ رَكَعَاتٍ مَجْمُوْعًا بِالعِشَاءِ جَمْعَ تَقْدِيْمٍ لِلهِ تَعَالَى

 Ushallî fardlal-maghribi tsalatsa raka‘âtin majmû‘an bil-‘isyâ’i jam‘a taqdîmin lillâhi ta‘ala

 Artinya: “Saya niat shalat fardlu maghrib tiga rakaat dijamak bersama isya dengan jamak taqdim karena Allah ta’ala”

 <strong>3.Muwalat(berurutan): </strong>
 Maksud berurutan adalah tidak ada jeda antara shalat pertama dengan shalat kedua, jadi setelah selesai shalat yang pertama harus segera takbiratul ihran untuk shalat yang kedua.

 <strong>4.Masih dalam perjalanan</strong>
 Ketika mengerjakan shalat yang kedua masih tetap dalam perjalanan, meskipun perjalanan itu tidak harus mencapai masafatul qashr.

 <strong>JAMAK TA'KHIR: </strong>
 Adapun syarat-syarat jamak ta’khir ada dua,

<strong>Pertama</strong>, niat jamak ta’khir yang dilakukan di waktu shalat yang pertama. Adapun <strong>lafal niat jamak ta’khir shalat dzuhur dan ashar</strong> adalah,

 أُصَلِّى فَرْضَ الظُّهْرِ أَرْبَعَ رَكَعَاتٍ مَجْمُوْعًا بِالْعَصْرِ جَمْعَ تأخِيْرٍلِلهِ تَعَالَى

 Ushallî fardladh-dhuhri arba‘a raka‘âtin majmû‘an bil-‘ashri jam‘a ta’khîrin lillâhi ta‘ala

 Artinya: “Saya niat shalat fardlu dzuhur empat rakaat dijamak bersama ashar dengan jama ta’khir karena Allah ta’ala”

 Adapun <strong>lafal niat shalat jamak ta’khir shalat maghrib dan isya </strong> adalah sebagaimana berikut:

 أُصَلِّى فَرْضَ المَغْرِبِ ثَلَاثَ رَكَعَاتٍ مَجْمُوْعًا بِالعِشَاءِ جَمْعَ تأخِيْرٍلِلهِ تَعَالَى

 Ushallî fardlal-maghribi tsalatsa raka‘âtin majmû‘an bil-‘isyâ’i jam‘a ta’khîrin lillâhi ta‘ala

 Artinya: “Saya niat shalat fardlu maghrib tiga rakaat dijamak bersama isya’ dengan jamak ta’khir karena Allah ta’ala”

 <strong>Kedua</strong>, ketika mengerjakan shalat yang kedua masih tetap dalam perjalanan sebagaimana keterangan pada jamak taqdim.

Semoga bermanfaat dan diamalkan sesuai dengan ketentuannya.
`;
